// Copyright (c) 2017 Deere & Company

import SelectedDealers, {getDefaultState} from '../state/selected-dealers';
import actions from '../actions-list';
import {updateList} from '../../../shared/services/list-selections';

const resetDealers = state =>
    SelectedDealers.update(state, {
        $set: getDefaultState()
    });

const selectDealer = (state, action) =>
    SelectedDealers.update(state, {
        $set: updateList(
            action.dealer,
            action.isSelected,
            'account',
            state
        )
    });

const selectAllDealers = (state, action) => {

    const toggleSelectedDealersState = state.length > 0 ? [] : action.dealers;

    return SelectedDealers.update(state, {
        $set: toggleSelectedDealersState
    });

};

const selectAllDealersOnLoad = (state, action) =>
    SelectedDealers.update(state, {
        $set: action.dealers
    });

export default (state = getDefaultState(), action) => {

    const actionTypes = {
        [actions.RESET_ADVANCED_CLAIM_SUMMARY_DEALERS]: resetDealers,
        [actions.SELECT_ADVANCED_CLAIM_SUMMARY_DEALER]: selectDealer,
        [actions.SELECT_ALL_ADVANCED_CLAIM_SUMMARY_DEALERS]: selectAllDealers,
        [actions.SELECT_ALL_ADVANCED_CLAIM_SUMMARY_DEALERS_ON_LOAD]: selectAllDealersOnLoad
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/reports/advanced-claim-summary/reducers/dealer-selection.js